<template>
    <v-card>
        <v-card-title>
            <span class="subtitle-2 font-weight-bold">주문내역</span>
            <v-spacer/>
            <span class="subtitle-2">총 주문금액 <b>{{ summary.totalAmount.format() }}</b>원</span>
        </v-card-title>
        <v-divider/>
        <v-data-table :items="purchases" :headers="purchasesHeaders" disable-sort hide-default-footer>
            <template slot="item.createdAt" slot-scope="{item}">
                {{ $dayjs(item.createdAt).format("YYYY-MM-DD HH:mm:ss") }}
            </template>
            <template slot="item.order.totalAmount" slot-scope="{item}">
                {{ item.order?.totalAmount?.format?.() }}원
            </template>
        </v-data-table>
        <v-divider/>
        <v-card-text>
            <v-pagination v-model="page" :length="pageCount" total-visible="11" @input="search" />
        </v-card-text>
    </v-card>
</template>

<script>
import api from "@/api";
export default {
    data(){
        return {
            page: 1,
            pageCount: 0,
            limit: 10,

            summary: { totalCount: 0, totalAmount: 0 },
            purchases: [],
            purchasesHeaders: [
                { text: "주문일자", value: "createdAt" },
                { text: "주문번호", value: "order.orderNo" },
                { text: "구매주문번호", value: "purchaseNo" },
                { text: "주문금액", value: "order.totalAmount" },
                { text: "주문상태", value: "status" },
            ]
        }
    },
    mounted(){
        this.init();
    },
    methods: {
        async init(){
            await this.search();

            this.ready = true;
        },
        async search(){
            let { summary, purchases } = await api.console.members.purchases.gets(this.$route.params._member, {
                headers: {
                    skip: (this.page - 1) * this.limit,
                    limit: this.limit
                },
                params: {
                    paymentStatus: ["결제완료", "환불완료"]
                }
            });

            this.summary = summary;
            this.purchases = purchases;
            this.pageCount = Math.ceil(summary.totalCount / this.limit);
        }
    }
}
</script>